<template>
  <div class="container no-margin">
    <number-input
      :label="label"
      :hint="hint"
      :value="value"
      :name="inputName"
      :required="required"
      :maxlength="maxlength"
      @click="$emit('click')"
      @onFocus="$emit('onFocus')"
      @input="onInput"
      :analyticsName="analyticsName"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import { tiposDocumentos } from "@/config/constants";
import NumberInput from "@/components/core/NumberInput";
export default {
  name: "DniInput",
  components: { NumberInput },
  props: {
    placeholder: String,
    label: String,
    value: String,
    name: String,
    inputName: String,
    required: Boolean,
    maxlength: String,
    tipoDoc: String,
    hint: String,
    analyticsName: {
      type: String,
      default: null
    },
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput(val) {
      /**
       * Si el DNI es >= 92M abre las opciones DNE, actualiza el tipoDoc del model
       */
      this.$emit("input", val);
      if (val >= 92000000) {
        this.$emit("update:tipoDoc", tiposDocumentos["DNE"]);
      } else {
        this.$emit("update:tipoDoc", tiposDocumentos["DNI"]);
      }
    }
  }
};
</script>
